var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getActiveDiagram } from './theme';
/** Top edge highlight for depth on dark cards. */
export function addTopSheen(app, parent, width, cornerRadius) {
    if (cornerRadius === void 0) { cornerRadius = getActiveDiagram().radii.md; }
    if (cornerRadius >= getActiveDiagram().radii.pill)
        return;
    var inset = Math.min(10, cornerRadius + 2);
    parent.add(app.line({
        x: inset,
        y: 1,
        x2: width - inset,
        y2: 1,
        stroke: getActiveDiagram().sheen,
        strokeWidth: 1,
        lineCap: 'round',
        listening: false,
    }));
}
/** Colored accent strip along the top of a card. */
export function addAccentBar(app, parent, width, color, height) {
    if (height === void 0) { height = 3; }
    parent.add(app.rect({
        x: 0,
        y: 0,
        width: width,
        height: height,
        fill: color,
        stroke: null,
        listening: false,
    }));
}
/** Left status or tier stripe on pipeline / org cards. */
export function addLeftStripe(app, parent, height, color, width) {
    if (width === void 0) { width = 4; }
    parent.add(app.rect({
        x: 0,
        y: 0,
        width: width,
        height: height,
        fill: color,
        stroke: null,
        listening: false,
    }));
}
/** Shared card body: rounded rect, optional accent, top sheen. */
export function addCardChrome(app, parent, opts) {
    var _a, _b, _c, _d, _e;
    var radius = (_a = opts.cornerRadius) !== null && _a !== void 0 ? _a : getActiveDiagram().radii.md;
    var strokeWidth = (_b = opts.strokeWidth) !== null && _b !== void 0 ? _b : getActiveDiagram().stroke.node;
    parent.add(app.roundedRect(__assign(__assign({ width: opts.width, height: opts.height, cornerRadius: radius, fill: opts.fill, stroke: opts.stroke, strokeWidth: strokeWidth }, (opts.shadow !== null && ((_c = opts.shadow) !== null && _c !== void 0 ? _c : getActiveDiagram().shadowSoft)
        ? { shadow: (_d = opts.shadow) !== null && _d !== void 0 ? _d : getActiveDiagram().shadowSoft }
        : {})), { listening: false })));
    // Square accent bar clips badly on pill radii — skip for capsules / state pills.
    if (opts.accentColor && radius < getActiveDiagram().radii.pill) {
        addAccentBar(app, parent, opts.width, opts.accentColor, (_e = opts.accentHeight) !== null && _e !== void 0 ? _e : 3);
    }
    if (opts.sheen !== false) {
        addTopSheen(app, parent, opts.width, radius);
    }
}
/** Caption pill behind network / schematic labels. */
export function addCaptionPill(app, parent, textWidth, x, y, accent) {
    if (accent === void 0) { accent = getActiveDiagram().labelPillStroke; }
    var fontSize = getActiveDiagram().fontSize.sm;
    var padX = 6;
    var pw = Math.max(textWidth + padX * 2, 24);
    var ph = fontSize + 6;
    parent.add(app.roundedRect({
        x: x + (textWidth - pw) / 2,
        y: y - 2,
        width: pw,
        height: ph,
        cornerRadius: getActiveDiagram().radii.sm,
        fill: getActiveDiagram().labelPillFill,
        stroke: accent,
        strokeWidth: getActiveDiagram().stroke.label,
        opacity: 0.92,
        listening: false,
    }));
}
/** Soft outer glow ring for emphasis (active pipeline, final state, etc.). */
export function addEmphasisRing(app, parent, width, height, color, cornerRadius) {
    var radius = cornerRadius !== null && cornerRadius !== void 0 ? cornerRadius : getActiveDiagram().radii.md;
    parent.add(app.roundedRect({
        x: -3,
        y: -3,
        width: width + 6,
        height: height + 6,
        cornerRadius: radius + 3,
        fill: null,
        stroke: color,
        strokeWidth: 1.5,
        opacity: 0.4,
        listening: false,
    }));
}
